var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lbs-viewer-container",
      class: {
        "tray-collapse": !_vm.leftSideVisible,
        "fill-browser-window": _vm.fillWindow
      },
      attrs: { id: _vm.viewerDivId }
    },
    [
      _vm.fillWindow
        ? _c(
            "section",
            { staticClass: "lbs-viewer-header" },
            [_c("popup-header", { attrs: { title: _vm.title } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "lbs-viewer-left-side" }, [
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.leftSideVisible,
                expression: "leftSideVisible"
              }
            ],
            staticClass: "lbs-viewer-left-side-content"
          },
          _vm._l(_vm.workflows, function(workflow, index) {
            return _c(workflow.component, {
              key: workflow.key,
              tag: "component",
              class: { "lbs-viewer-active": _vm.tabIndex === index },
              attrs: {
                config: _vm.config,
                "is-workflow-selected": _vm.tabIndex === index
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "nav",
          { staticClass: "lbs-viewer-left-side-nav" },
          [
            _c(
              "button",
              {
                staticClass: "lbs-viewer-button lbs-viewer-collapse-button",
                attrs: { title: _vm.toggleWorkflowTitle },
                on: {
                  click: function($event) {
                    return _vm.toggleLeftPanel()
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: require("./assets/collapse-icon.png") }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lbs-viewer-tab-container" },
              _vm._l(_vm.workflows, function(workflow, index) {
                return _c(
                  "button",
                  {
                    key: workflow.key,
                    staticClass: "lbs-viewer-button lbs-viewer-tab-button",
                    class: {
                      "lbs-viewer-tab-selected": _vm.tabIndex === index
                    },
                    attrs: { title: _vm.$t(workflow.title) },
                    on: {
                      click: function($event) {
                        return _vm.selectTab(index)
                      }
                    }
                  },
                  [_c("img", { attrs: { src: workflow.icon } })]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("vertical-label", { attrs: { title: _vm.title } })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("uscope-component", { attrs: { config: _vm.config } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/viewer/components/ViewerComponent.vue?vue&type=template&id=6b3c5806&scoped=true&
// module id = 302
// module chunks = 0